module.exports = __webpack_public_path__ + "media/images/middle-image2-d0b0c16ce97de994c8ccbe60db585817.png";